exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signup-form {\n  width: 100%; }\n\nh2 {\n  color: #9FB0BF;\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 16px; }\n\n.title {\n  width: 100%; }\n\n.field.column:not(.is-full) {\n  padding-top: 0px;\n  padding-bottom: 0px; }\n\n.select, .select select {\n  width: 100%; }\n\n.help {\n  text-align: left; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/login/login-form/login-form.component.scss
// module id = ../../../../../src/app/login/login-form/login-form.component.scss
// module chunks = 1